import React, { useContext, useEffect, useState } from 'react';
import { IframeDialog } from '../../../atoms/dialog';
import { ButtonAction, getIframeLegacyUrl, InputValue } from '../donate-form-utils';
import { DonateFormContext } from '../DonateFormContext';
import DonateFormButton from './DonateFormButton';

interface CreditCardDonationProps {
    action: ButtonAction;
}

const toQueryParam = (object: {[key in string]: InputValue}) => {
    return Object.entries(object).map((x) => `${x[0]}=${encodeURIComponent(x[1] as string)}`).join('&');
}

const CreditCardDonation = ({action}: CreditCardDonationProps) => {
    const {formState, canSubmitForm, config} = useContext(DonateFormContext);
    const {legacyUrl} = config;
    const [isDialogActive, setIsDialogActive] = useState(false);

    // while legacy might be portal.test.giveeasy
    // the actual URL we use is test.giveeasy
    const iframeLegacyUrl = getIframeLegacyUrl(legacyUrl);

    const iframeUrl = `${iframeLegacyUrl}/donate/IframePage?${toQueryParam(formState)}&app_key=AxEppXJU99KGBJWBCt6mdDq3QsmW0B0O&result_url=${iframeLegacyUrl}/donate/desktop/callback&isPayPal=false`;

    const processIframeResult = (e: MessageEvent) => {
        e.preventDefault();

        const {Code, Amount, RefId, Sign, Message} = e.data;

        if (Code === 0) {
            window.location.assign(`${iframeLegacyUrl}/donate/desktop/success?amount=${Amount}&refId=${RefId}&sign=${Sign}`);

            return;
        }

        const message = Message ?? 'Payment Failure';
        window.alert(`Sorry, we were unable to process your donation. Please try again\n${message}`);

        return;
    }
    useEffect(() => {
        if (isDialogActive) {
            window.addEventListener('message', processIframeResult);

            return;
        }

        window.removeEventListener('message', processIframeResult);
    }, [isDialogActive]);

    return (
        <div>
            <DonateFormButton
                id="credit-card-donate"
                action={action}
                onClick={() => setIsDialogActive(true)}
                disabled={!canSubmitForm}
            />
            <IframeDialog
                isOpen={isDialogActive}
                iframeSrc={iframeUrl}
                isCloseButtonOnLeft={true}
                width="350px"
                height="460px"
                onClose={() => setIsDialogActive(false)}
            />
        </div>
    )
}

export default CreditCardDonation;
